import { Controller } from "@hotwired/stimulus";
import { scrollToElementWithOffset } from "../../javascripts/utils";

export default class extends Controller<HTMLDivElement> {
  static values = {
    currentQuestion: Number,
    flashVisible: Boolean,
  };
  static targets = ["question", "endPanel"];

  declare questionTargets: Array<HTMLDivElement>;
  declare currentQuestionValue: number;
  declare current_question_index: number;
  declare endPanelTarget: HTMLDivElement;
  declare flashVisibleValue: boolean;

  connect() {
    this.current_question_index = this.currentQuestionValue;
    this.displayQuestion();
  }

  next() {
    this.currentQuestion().classList.add("d-none");
    this.current_question_index += 1;

    this.displayQuestion();
  }

  displayQuestion() {
    const question = this.currentQuestion();
    let scrollTarget: HTMLElement;

    if (question) {
      question.classList.remove("d-none");
      scrollTarget = question;
    } else {
      this.endPanelTarget.classList.remove("d-none");
      scrollTarget = this.element;
    }

    if (this.flashVisibleValue) return;

    scrollToElementWithOffset(scrollTarget);
  }

  currentQuestion() {
    return this.questionTargets[this.current_question_index];
  }

  hide() {
    this.element.classList.add("d-none");
  }
}
